import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'walletUnbindAlipay',
  state: {
    demoData: {}
  },
  effects: {
    * unbindAlipay ({ payload }, { call, put }) {
      const res = yield call(service.unbindAlipay, payload)
      const { data } = res
      if (data.status === 200) {
        Toast.info('解绑成功')
      } else {
        // Toast.info('解绑失败，请重试!')
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
